export default __webpack_public_path__ + "static/grouped-column-9cb382e4ff90789f6cca934e791c1502.png";